// Libraries
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'

// Images
import Rodrigo from '../../assets/images/testimonials/rodrigo-calderon.png'
import Rodrigo2X from '../../assets/images/testimonials/rodrigo-calderon@2x.png'
import Gabriel from '../../assets/images/testimonials/gabriel-vinderola.png'
import Gabriel2X from '../../assets/images/testimonials/gabriel-vinderola@2x.png'
import Joaquin_Ramiro from '../../assets/images/testimonials/joaquin-ramiro.png'
import Joaquin_Ramiro2X from '../../assets/images/testimonials/joaquin-ramiro@2x.png'

// Icons
import { ReactComponent as IconBack } from '../../assets/icons/Back.svg'
import { ReactComponent as IconNext } from '../../assets/icons/Next.svg'
import { Trans } from 'react-i18next'

const ArrowBack = (props) => {
  return (
    <button className={props.className} onClick={props.onClick}>
      <IconBack />
    </button>
  )
}

const ArrowNext = (props) => {
  return (
    <button className={props.className} onClick={props.onClick}>
      <IconNext />
    </button>
  )
}

const Testimonials = () => {
  var settings = {
    // dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    prevArrow: <ArrowBack />,
    nextArrow: <ArrowNext />
  }
  return (
    <section className="spa">
      <div className="container" data-aos="fade">
        <Slider {...settings} className="testimonials__carousel">
          {/* Testimonio 1:start */}
          <div className="testimonio d-flex">
            <div className="testimonio__frase font-weight--500">
              <p>
                <Trans i18nKey="testimonials.rodrigo.testimony" />
              </p>

              <p className="testimonio__autor d-none d-md-flex align-items-center color--olivo">
                <span className="font-weight--600">Rodrigo Calderón</span>
                <br></br>
                <div className="separador d-flex bg--olivo"></div>
                <Trans i18nKey="testimonials.rodrigo.position" />
              </p>
            </div>

            <img className="testimonio__imagen" src={Rodrigo} srcSet={Rodrigo2X + ' 2x'} alt="Rodrigo Calderón" />

            <p className="testimonio__autor d-md-none color--olivo">
              <span className="font-weight--600">Rodrigo Calderón</span>
              <Trans i18nKey="testimonials.rodrigo.position" />
            </p>
          </div>
          {/* Testimonio 1:end */}
          {/* Testimonio 2:start */}
          <div className="testimonio d-flex">
            <div className="testimonio__frase font-weight--500">
              <p>
                <Trans i18nKey="testimonials.gabriel.testimony" />
              </p>

              <p className="testimonio__autor d-none d-md-flex align-items-center color--olivo">
                <span className="font-weight--600">Dr. Gabriel Vinderola</span>
                <br></br>
                <div className="separador d-flex bg--olivo"></div>
                <Trans i18nKey="testimonials.gabriel.position" />
              </p>
            </div>

            <img className="testimonio__imagen" src={Gabriel} srcSet={Gabriel2X + ' 2x'} alt="Gabriel Vinderola" />

            <p className="testimonio__autor d-md-none color--olivo">
              <span className="font-weight--600">Dr. Gabriel Vinderola</span>
              <Trans i18nKey="testimonials.gabriel.position" />
            </p>
          </div>
          {/* Testimonio 2:end */}
          {/* Testimonio 3:start */}
          <div className="testimonio d-flex">
            <div className="testimonio__frase font-weight--500">
              <p>
                <Trans i18nKey="testimonials.nero.testimony" />
              </p>

              <p className="testimonio__autor d-none d-md-flex align-items-center color--olivo">
                <span className="font-weight--600">NERO COCINA</span>
                <br></br>
                <div className="separador d-flex bg--olivo"></div>
                Joaquín L. y Ramiro K.
              </p>
            </div>

            <img className="testimonio__imagen" src={Joaquin_Ramiro} srcSet={Joaquin_Ramiro2X + ' 2x'} alt="NERO COCINA" />

            <p className="testimonio__autor d-md-none color--olivo">
              <span className="font-weight--600">NERO COCINA</span>
              Joaquín L. y Ramiro K.
            </p>
          </div>
          {/* Testimonio 3:end */}
        </Slider>
      </div>
    </section>
  )
}
export default Testimonials
